import { useContext } from 'react';

import { ViewerContext } from '@vimeo/viewer';

export function useViewer() {
  return useContext(ViewerContext);
}

export function useAuthenticatedViewer() {
  const viewer = useContext(ViewerContext);

  const isViewerAuthenticated = !!viewer?.user;

  return viewer && isViewerAuthenticated ? viewer : null;
}
